// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
:root {
  --bs-font-sans-serif: "Barlow Regular" , sans-serif!important;
  --bs-btn-padding-x: 0.55rem!important;
  --bs-btn-padding-y: 0.15rem!important;
  scroll-behavior: smooth;
  scrollbar-width: thin !important;

}

/* .dark-theme{
  --body-color:#999;
  --nav-color: #fff;
  --bg-color: #333;
      --dark: #ff771d;
      --body-bg-color:#000;
      --divider: #333;
      --hdr-shadow: rgba(255, 255, 255, 0.25);
      --bs-accordion-btn-color:#fff;
} */

.main-content {
  width: calc(100% - 255px);
  float: left;
  min-height: 950px;
}


a {
  text-decoration: none!important;
}

a:hover {
  text-decoration: none;
}



/*--------------------------------------------------------------
# Main
--------------------------------------------------------------*/
#main {
  margin-top: 0;
  padding: 20px 0;
  transition: all 0.3s;
  /*  border:1px solid #000;*/

}

@media (max-width: 1199px) {
  #main {
      padding: 20px;
  }
}

/*--------------------------------------------------------------
# Page Title
--------------------------------------------------------------*/
.pagetitle {
  margin-bottom: 10px;
}

.pagetitle h1 {
  font-size: 24px;
  margin-bottom: 0;
  font-weight: 600;
}

/*--------------------------------------------------------------
# Back to top button
--------------------------------------------------------------*/
/* .back-to-top {
position: fixed;
visibility: hidden;
opacity: 0;
right: 15px;
bottom: 15px;
z-index: 99999;
background: #4154f1;
width: 40px;
height: 40px;
border-radius: 4px;
transition: all 0.4s;
}

.back-to-top i {
font-size: 24px;
color: #fff;
line-height: 0;
}

.back-to-top:hover {
background: #6776f4;
color: #fff;
}

.back-to-top.active {
visibility: visible;
opacity: 1;
} */

/*--------------------------------------------------------------
# Override some default Bootstrap stylings
--------------------------------------------------------------*/
/* Dropdown menus */
.dropdown-menu {
  border-radius: 4px;
  padding: 10px 0;
  animation-name: dropdown-animate;
  animation-duration: 0.2s;
  animation-fill-mode: both;
  border: 0;
  box-shadow: 0 5px 30px 0 rgba(82, 63, 105, 0.2);
}

.dropdown-menu .dropdown-header,
.dropdown-menu .dropdown-footer {
  text-align: center;
  font-size: 15px;
  padding: 10px 25px;
}

.dropdown-menu .dropdown-footer a {
  color: #444444;
  text-decoration: underline;
}

.dropdown-menu .dropdown-footer a:hover {
  text-decoration: none;
}

.dropdown-menu .dropdown-divider {
  color: #8d8d8d;
  margin: 0;
}

.dropdown-menu .dropdown-item {
  font-size: 14px;
  padding: 5px 15px;
  transition: 0.3s;
}

.dropdown-menu .dropdown-item i {
  margin-right: 10px;
  font-size: 18px;
  line-height: 0;
}

.dropdown-menu .dropdown-item:hover {
  background-color: var(--bs-gray-600);
  color:#fff;
}

@media (min-width: 768px) {
  .dropdown-menu-arrow::before {
      content: "";
      width: 13px;
      height: 13px;
      background: var(--bs-bw2-color);
      position: absolute;
      top: -7px;
      right: 20px;
      transform: rotate(45deg);
      border-top: 1px solid #444;
      border-left: 1px solid #444;
  }
}

@keyframes dropdown-animate {
  0% {
      opacity: 0;
  }

  100% {
      opacity: 1;
  }

  0% {
      opacity: 0;
  }
}

/* Light Backgrounds */
.bg-primary-light {
  background-color: #cfe2ff;
  border-color: #cfe2ff;
}

.bg-secondary-light {
  background-color: #e2e3e5;
  border-color: #e2e3e5;
}

.bg-success-light {
  background-color: #d1e7dd;
  border-color: #d1e7dd;
}

.bg-danger-light {
  background-color: #f8d7da;
  border-color: #f8d7da;
}

.bg-warning-light {
  background-color: #fff3cd;
  border-color: #fff3cd;
}

.bg-info-light {
  background-color: #cff4fc;
  border-color: #cff4fc;
}

.bg-dark-light {
  background-color: #d3d3d4;
  border-color: #d3d3d4;
}

/* Card */
.card {
  margin-bottom: 30px;
  border: none;
  border-radius: 5px;
  box-shadow: 0px 0 30px rgba(1, 41, 112, 0.1);
  /* min-height:100px; */
}

.card-header,
.card-footer {
  border-color: #ebeef4;
  background-color: #fff;
  color: #798eb3;
  padding: 15px;
}

.card-title {
  padding: 10px 0 0 0;
  font-size: 18px;
  font-weight: 500;
  color: var(--bs-link-color);
}

.card-title span {
  color: #000000;
  font-size: 14px;
  font-weight: 400;
}

.card-body {
  padding: 0 20px 20px 20px;
}

.card-img-overlay {
  background-color: rgba(0, 0, 0, 0.25);
}

/* Alerts */
.alert-heading {
  font-weight: 500;
  font-family: "Barlow Regular", sans-serif;
  font-size: 20px;
}

/* Close Button */
.btn-close {
  background-size: 25%;
}

.btn-close:focus {
  outline: 0;
  box-shadow: none;
}

/* Accordion */
/* .accordion-item {
border: 1px solid #ebeef4;
}

.accordion-button:focus {
outline: 0;
box-shadow: none;
}

.accordion-button:not(.collapsed) {
color: var(--nav-color);
background-color: var(--bg-color);
}

.accordion-flush .accordion-button {
padding: 15px 0;
background: none;
border: 0;
}

.accordion-flush .accordion-button:not(.collapsed) {
box-shadow: none;
color: #4154f1;
}

.accordion-flush .accordion-body {
padding: 0 0 15px 0;
color: #3e4f6f;
font-size: 15px;
} */

/* Breadcrumbs */
.breadcrumb {
  font-size: 14px;
  font-family: "Barlow Regular", sans-serif;
  color: #899bbd;
  font-weight: 600;
}

.breadcrumb a {
  color: #899bbd;
  transition: 0.3s;
}

.breadcrumb a:hover {
  color: #51678f;
}

.breadcrumb .breadcrumb-item::before {
  color: #899bbd;
}

.breadcrumb .active {
  color: #51678f;
  font-weight: 600;
}

/* Bordered Tabs */
/* .nav-tabs-bordered {
border-bottom: 2px solid #ebeef4;
} */

/* .nav-tabs-bordered .nav-link {
margin-bottom: -2px;
border: none;
color: #2c384e;
} */

/* .nav-tabs-bordered .nav-link:hover,
.nav-tabs-bordered .nav-link:focus {
color: #4154f1;
} */

/* .nav-tabs-bordered .nav-link.active {
background-color: #fff;
color: #4154f1;
border-bottom: 2px solid #4154f1;
} */

/*--------------------------------------------------------------
# Header
--------------------------------------------------------------*/
.logo {
  line-height: 1;
}

@media (min-width: 1200px) {
  .logo {
      width: 280px;
  }
}
#sidebar .logo {
  padding: 0px;
  /* text-align: left; */
  width: 100%;
}
.logo img {
  max-height: 70px;
  margin-right: 6px;
  /* filter:brightness(var(--logo-filter))!important; */
}

.logo span {
  font-size: 26px;
  font-weight: 700;
  color: #012970;
  font-family: "Barlow Regular", sans-serif;
}

.header {
  transition: all 0.5s;
  z-index: 997;
  height: 60px;
  /* box-shadow: 0px 1px 3px var(--bs-gray-500); */
  /* border-bottom: 2px solid var(--bs-border-color); */
  background-color: var(--body-bg-color);
  padding-left: 20px;
  /* position:absolute; */
  margin-left:236px;
  /* Toggle Sidebar Button */
  /* Search Bar */
  right:0;

}

.header .toggle-sidebar-btn {
  font-size: 32px;
  padding-left: 10px;
  cursor: pointer;
  color: var(--bs-light);
}

.header .search-bar {
  min-width: 360px;
  padding: 0 20px;
}

@media (max-width: 1199px) {
  .header .search-bar {
      position: fixed;
      top: 50px;
      left: 0;
      right: 0;
      padding: 20px;
      box-shadow: 0px 0px 15px 0px rgba(1, 41, 112, 0.1);
      background: white;
      z-index: 9999;
      transition: 0.3s;
      visibility: hidden;
      opacity: 0;
  }

  .header .search-bar-show {
      top: 60px;
      visibility: visible;
      opacity: 1;
  }
}

.header .search-form {
  width: 100%;
}

.header .search-form input {
  border: 0;
  font-size: 14px;
  /*color: var(--bg-color); */
  /* border: 1px solid var(--bs-gray-300); */
  padding: 7px 38px 7px 8px;
  border-radius: 3px;
  transition: 0.3s;
  width: 100%;
  background: var(--body-bg-color);
}

.header .search-form input:focus,
.header .search-form input:hover {
  outline: none;
  box-shadow: 0 0 10px 0 rgba(1, 41, 112, 0.15);
  border: 1px solid rgba(1, 41, 112, 0.3);
}

.header .search-form button {
  border: 0;
  padding: 0;
  margin-left: -30px;
  background: none;
}

.header .search-form button i {
  color: var(--bg-color);
}

/*--------------------------------------------------------------
# Header Nav
--------------------------------------------------------------*/
.header-nav ul {
  list-style: none;
}

.header-nav>ul {
  margin: 0;
  padding: 0;
}

.header-nav .nav-icon {
  font-size: 22px;
  color: var(--nav-color);
  margin-right: 5px;
  position: relative;
}

.header-nav .nav-profile {
  color: var(--nav-color);
}

.header-nav .nav-profile img {
  max-height: 40px;
}

.header-nav .nav-profile span {
  font-size: 14px;
  /* font-weight: 600; */
}

.header-nav .badge-number {
  position: absolute;
  inset: -2px -5px auto auto;
  font-weight: normal;
  font-size: 12px;
  padding: 3px 6px;
}
.header-nav .badge-online {
  position: absolute;
  inset: -2px -5px auto auto;
  font-weight: normal;
  font-size: 12px;
  padding: 3px 3px;
}

.header-nav .notifications {
  inset: 8px -15px auto auto !important;
}

.header-nav .notifications .notification-item {
  display: flex;
  align-items: center;
  padding: 15px 10px;
  transition: 0.3s;
}

.header-nav .notifications .notification-item i {
  margin: 0 20px 0 10px;
  font-size: 24px;
}

.header-nav .notifications .notification-item h4 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 5px;
}

.header-nav .notifications .notification-item p {
  font-size: 13px;
  margin-bottom: 3px;
  color: #919191;
}

.header-nav .notifications .notification-item:hover {
  background-color: #f6f9ff;
}

.header-nav .messages {
  inset: 8px -15px auto auto !important;
}

.header-nav .messages .message-item {
  padding: 15px 10px;
  transition: 0.3s;
}

.header-nav .messages .message-item a {
  display: flex;
}

.header-nav .messages .message-item img {
  margin: 0 20px 0 10px;
  max-height: 40px;
}

.header-nav .messages .message-item h4 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 5px;
  color: #444444;
}

.header-nav .messages .message-item p {
  font-size: 13px;
  margin-bottom: 3px;
  color: #919191;
}

.header-nav .messages .message-item:hover {
  background-color: #f6f9ff;
}

.header-nav .profile {
  min-width: 240px;
  padding-bottom: 0;
  top: 8px !important;
}

.header-nav .profile .dropdown-header h6 {
  font-size: 18px;
  margin-bottom: 0;
  font-weight: 600;
}

.header-nav .profile .dropdown-header span {
  font-size: 14px;
}

.header-nav .profile .dropdown-item {
  font-size: 14px;
  padding: 10px 15px;
  transition: 0.3s;
}

.header-nav .profile .dropdown-item i {
  margin-right: 10px;
  font-size: 18px;
  line-height: 0;
}

.header-nav .profile .dropdown-item:hover {
  /* background-color: var(--bg-color); */
}

/*--------------------------------------------------------------
# Sidebar
--------------------------------------------------------------*/
.sidebar {
  transition: all 0.3s;
  position: fixed;
  top: 0;
  bottom: 0;
  width: 235px;
  z-index: 996;
  padding: 20px 7px;
  overflow:hidden;
  /* overflow-y: auto;
  overflow-x:hidden;
  scrollbar-width: thin;
  scrollbar-color: var(--body-color) transparent; */
  box-shadow: 0px 0px 20px rgba(1, 41, 112, 0.1);
  background-color: var(--body-bg-color);
}

.lsbar{
  left:0;
  transition: all 0.3s;
}
.rsbar{
  right:0;
  transition: all 0.3s;
}

@media (max-width: 1199px) {
  .sidebar {
      left: -275px;
  }
}

.sidebar::-webkit-scrollbar {
  width: 5px;
  height: 8px;
  background-color: #fff;
}

.sidebar::-webkit-scrollbar-thumb {
  background-color: #aab7cf;
}

@media (min-width: 1200px) {

  #main,
  #footer {
      margin-left: 240px;
      margin-right:240px;
  }
}

@media (max-width: 1199px) {
  .toggle-sidebar .sidebar {
      left: 0;
  }
}

@media (min-width: 1200px) {

  .toggle-sidebar #main,
  .toggle-sidebar #footer {
      margin-left: 0;
  }

  .toggle-sidebar .sidebar {
      left: -300px;
  }
}

.sidebar-nav {
  padding: 0;
  margin: 0;
  list-style: none;
}

.sidebar-nav li {
  padding: 0;
  margin: 0;
  list-style: none;
}
.sidebar-nav .nav-item {
  margin-bottom: 0px;
}

.sidebar-nav .nav-heading {
  font-size: 11px;
  text-transform: uppercase;
  color: #899bbd;
  font-weight: 600;
  margin: 10px 0 5px 15px;
}

.sidebar-nav .nav-link {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 600;
  color: #4154f1;
  transition: 0.3;
  background: #f6f9ff;
  padding: 10px 15px;
  border-radius: 4px;
}

.sidebar-nav .nav-link i {
  font-size: 16px;
  margin-right: 10px;
  color: #4154f1;
}

.sidebar-nav .nav-link.collapsed {
  color: #012970;
  background: #fff;
}

.sidebar-nav .nav-link.collapsed i {
  color: #899bbd;
}

.sidebar-nav .nav-link:hover {
  color: #4154f1;
  background: #f6f9ff;
}

.sidebar-nav .nav-link:hover i {
  color: #4154f1;
}

.sidebar-nav .nav-link .bi-chevron-down {
  margin-right: 0;
  transition: transform 0.2s ease-in-out;
}

.sidebar-nav .nav-link:not(.collapsed) .bi-chevron-down {
  transform: rotate(180deg);
}

.sidebar-nav .nav-content {
  padding: 5px 0 0 0;
  margin: 0;
  list-style: none;
}

.sidebar-nav .nav-content a {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: #012970;
  transition: 0.3;
  padding: 10px 0 10px 40px;
  transition: 0.3s;
}

.sidebar-nav .nav-content a i {
  font-size: 6px;
  margin-right: 8px;
  line-height: 0;
  border-radius: 50%;
}

.sidebar-nav .nav-content a:hover,
.sidebar-nav .nav-content a.active {
  color: #4154f1;
}

.sidebar-nav .nav-content a.active i {
  background-color: #4154f1;
}

/*--------------------------------------------------------------
# Dashboard
--------------------------------------------------------------*/
/* Filter dropdown */
.dashboard .filter {
  position: absolute;
  right: 0px;
  top: 15px;
}

.dashboard .filter .icon {
  color: #aab7cf;
  padding-right: 20px;
  padding-bottom: 5px;
  transition: 0.3s;
  font-size: 16px;
}

.dashboard .filter .icon:hover,
.dashboard .filter .icon:focus {
  color: #4154f1;
}

.dashboard .filter .dropdown-header {
  padding: 8px 15px;
}

.dashboard .filter .dropdown-header h6 {
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1px;
  color: #aab7cf;
  margin-bottom: 0;
  padding: 0;
}

.dashboard .filter .dropdown-item {
  padding: 8px 15px;
}

/* Info Cards */
.dashboard .info-card {
  padding-bottom: 10px;
}

.dashboard .info-card h6 {
  font-size: 28px;
  color: #012970;
  font-weight: 700;
  margin: 0;
  padding: 0;
}

.dashboard .card-icon {
  font-size: 32px;
  line-height: 0;
  width: 64px;
  height: 64px;
  flex-shrink: 0;
  flex-grow: 0;
}

.dashboard .sales-card .card-icon {
  color: #4154f1;
  background: #f6f6fe;
}

.dashboard .revenue-card .card-icon {
  color: #2eca6a;
  background: #e0f8e9;
}

.dashboard .customers-card .card-icon {
  color: #ff771d;
  background: #ffecdf;
}

/* Activity */
.dashboard .activity {
  font-size: 14px;
}

.dashboard .activity .activity-item .activite-label {
  color: #888;
  position: relative;
  flex-shrink: 0;
  flex-grow: 0;
  min-width: 64px;
}

.dashboard .activity .activity-item .activite-label::before {
  content: "";
  position: absolute;
  right: -11px;
  width: 4px;
  top: 0;
  bottom: 0;
  background-color: #eceefe;
}

.dashboard .activity .activity-item .activity-badge {
  margin-top: 3px;
  z-index: 1;
  font-size: 11px;
  line-height: 0;
  border-radius: 50%;
  flex-shrink: 0;
  border: 3px solid #fff;
  flex-grow: 0;
}

.dashboard .activity .activity-item .activity-content {
  padding-left: 10px;
  padding-bottom: 20px;
}

.dashboard .activity .activity-item:first-child .activite-label::before {
  top: 5px;
}

.dashboard .activity .activity-item:last-child .activity-content {
  padding-bottom: 0;
}

/* News & Updates */
.dashboard .news .post-item+.post-item {
  margin-top: 15px;
}

.dashboard .news img {
  width: 80px;
  float: left;
  border-radius: 5px;
}

.dashboard .news h4 {
  font-size: 15px;
  margin-left: 95px;
  font-weight: bold;
  margin-bottom: 5px;
}

.dashboard .news h4 a {
  color: #012970;
  transition: 0.3s;
}

.dashboard .news h4 a:hover {
  color: #4154f1;
}

.dashboard .news p {
  font-size: 14px;
  color: #777777;
  margin-left: 95px;
}

/* Recent Sales */
.dashboard .recent-sales {
  font-size: 14px;
}

.dashboard .recent-sales .table thead {
  background: #f6f6fe;
}

.dashboard .recent-sales .table thead th {
  border: 0;
}

.dashboard .recent-sales .dataTable-top {
  padding: 0 0 10px 0;
}

.dashboard .recent-sales .dataTable-bottom {
  padding: 10px 0 0 0;
}

/* Top Selling */
.dashboard .top-selling {
  font-size: 14px;
}

.dashboard .top-selling .table thead {
  background: #f6f6fe;
}

.dashboard .top-selling .table thead th {
  border: 0;
}

.dashboard .top-selling .table tbody td {
  vertical-align: middle;
}

.dashboard .top-selling img {
  border-radius: 5px;
  max-width: 60px;
}

/*--------------------------------------------------------------
# Icons list page
--------------------------------------------------------------*/
.iconslist {
  display: grid;
  max-width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 1.25rem;
  padding-top: 15px;
}

.iconslist .icon {
  background-color: #fff;
  border-radius: 0.25rem;
  text-align: center;
  color: #012970;
  padding: 15px 0;
}

.iconslist i {
  margin: 0.25rem;
  font-size: 2.5rem;
}

.iconslist .label {
  font-family: var(--bs-font-monospace);
  display: inline-block;
  width: 100%;
  overflow: hidden;
  padding: 0.25rem;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #666;
}

/*--------------------------------------------------------------
# Profie Page
--------------------------------------------------------------*/
.profile .profile-card img {
  max-width: 120px;
}

.profile .profile-card h2 {
  font-size: 24px;
  font-weight: 700;
  color: #2c384e;
  margin: 10px 0 0 0;
}

.profile .profile-card h3 {
  font-size: 18px;
}

.profile .profile-card .social-links a {
  font-size: 20px;
  display: inline-block;
  color: rgba(1, 41, 112, 0.5);
  line-height: 0;
  margin-right: 10px;
  transition: 0.3s;
}

.profile .profile-card .social-links a:hover {
  color: #012970;
}

.profile .profile-overview .row {
  margin-bottom: 20px;
  font-size: 15px;
}

.profile .profile-overview .card-title {
  color: #012970;
}

.profile .profile-overview .label {
  font-weight: 600;
  color: rgba(1, 41, 112, 0.6);
}

.profile .profile-edit label {
  font-weight: 600;
  color: rgba(1, 41, 112, 0.6);
}

.profile .profile-edit img {
  max-width: 120px;
}

/*--------------------------------------------------------------
# F.A.Q Page
--------------------------------------------------------------*/
.faq .basic h6 {
  font-size: 18px;
  font-weight: 600;
  color: #4154f1;
}

.faq .basic p {
  color: #6980aa;
}

/*--------------------------------------------------------------
# Contact
--------------------------------------------------------------*/
.contact .info-box {
  padding: 28px 30px;
}

.contact .info-box i {
  font-size: 38px;
  line-height: 0;
  color: #4154f1;
}

.contact .info-box h3 {
  font-size: 20px;
  color: #012970;
  font-weight: 700;
  margin: 20px 0 10px 0;
}

.contact .info-box p {
  padding: 0;
  line-height: 24px;
  font-size: 14px;
  margin-bottom: 0;
}

.contact .php-email-form .error-message {
  display: none;
  color: #fff;
  background: #ed3c0d;
  text-align: left;
  padding: 15px;
  margin-bottom: 24px;
  font-weight: 600;
}

.contact .php-email-form .sent-message {
  display: none;
  color: #fff;
  background: #18d26e;
  text-align: center;
  padding: 15px;
  margin-bottom: 24px;
  font-weight: 600;
}

.contact .php-email-form .loading {
  display: none;
  background: #fff;
  text-align: center;
  padding: 15px;
  margin-bottom: 24px;
}

.contact .php-email-form .loading:before {
  content: "";
  display: inline-block;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  margin: 0 10px -6px 0;
  border: 3px solid #18d26e;
  border-top-color: #eee;
  animation: animate-loading 1s linear infinite;
}

.contact .php-email-form input,
.contact .php-email-form textarea {
  border-radius: 0;
  box-shadow: none;
  font-size: 14px;
  border-radius: 0;
}

.contact .php-email-form input:focus,
.contact .php-email-form textarea:focus {
  border-color: #4154f1;
}

.contact .php-email-form input {
  padding: 10px 15px;
}

.contact .php-email-form textarea {
  padding: 12px 15px;
}

.contact .php-email-form button[type=submit] {
  background: #4154f1;
  border: 0;
  padding: 10px 30px;
  color: #fff;
  transition: 0.4s;
  border-radius: 4px;
}

.contact .php-email-form button[type=submit]:hover {
  background: #5969f3;
}

@keyframes animate-loading {
  0% {
      transform: rotate(0deg);
  }

  100% {
      transform: rotate(360deg);
  }
}

/*--------------------------------------------------------------
# Error 404
--------------------------------------------------------------*/
.error-404 {
  padding: 30px;
}

.error-404 h1 {
  font-size: 180px;
  font-weight: 700;
  color: #4154f1;
  margin-bottom: 0;
  line-height: 150px;
}

.error-404 h2 {
  font-size: 24px;
  font-weight: 700;
  color: #012970;
  margin-bottom: 30px;
}

.error-404 .btn {
  background: #51678f;
  color: #fff;
  padding: 8px 30px;
}

.error-404 .btn:hover {
  background: #3e4f6f;
}

@media (min-width: 992px) {
  .error-404 img {
      max-width: 50%;
  }
}

/*--------------------------------------------------------------
# Footer
--------------------------------------------------------------*/
.footer {
  padding: 20px 0;
  font-size: 14px;
  transition: all 0.3s;
  border-top: 1px solid #cddfff;
}

.footer .copyright {
  text-align: center;
  color: #012970;
}

.footer .credits {
  padding-top: 5px;
  text-align: center;
  font-size: 13px;
  color: #012970;
}
/*middle content css*/
.write-post-container {
  width: 100%;
  background: var(--body-bg-color);
  /* border-radius: 6px; */
  padding: 20px;
  color: #626262;
}
.post-container{
  width:100%;
  background: var(--body-bg-color);
  border-radius: 6px;
  padding: 20px;
  color:var(--bs-wb-color);
  margin:20px 0;
}
.post-input-container{
  padding-left: 55px;
  padding-top: 20px;
}
.post-input-container textarea{
  width:100%;
  border:0;
  outline:0;
  border-bottom:1px solid #ccc;
  background:transparent;
  resize:none;
}
.post-row{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.user-profile a{
  font-size: 12px;
  color: var(--nav-color);
  text-decoration: none;

}
.user-profile{
  display: flex;
  align-items: center;
}
.user-profile img{
  width: 45px;
  border-radius: 50%;
  margin-right: 10px;
}
.user-profile p{
  margin-bottom: 0px;
  font-weight: 700;
  color:#e30613;
}
.user-profile small{
  font-size: 12px;
}
.add-post-links{
  display: flex;
  margin-top:10px;
}
.add-post-links a{
  text-decoration: none;
  display: flex;
  align-items: center;
  color:#626262;
  margin-right: 30px;
  font-size:13px;
}
.add-post-links a img{
  width:20px;
  margin-right:10px;

}
.post-text{
  color:#9a9a9a;
  margin:15px 0;
  font-size:15px;
}
.post-text span{
  color: #626262;
  font-weight: 500;
}

.post-text a{
  color:var(--nav-color);
  text-decoration: none;
}
.post-img{
  width:100%;
  border-radius: 4px;
  margin-bottom:5px;
}
.activity-icons div img{
  width:18px;
  margin-right:10px;
}
.activity-icons div {
  display: inline-flex;
  align-items: center;
  margin-right:30px;
}
.post-profile-icon{
  display:flex;
  align-items: center;
}
.post-profile-icon img{
  width:20px;
  border-radius: 50%;
  margin-right:5px;
}
.load-more-btn{
  display: inherit;
  margin:auto;
  cursor:pointer;
  padding: 5px 10px;
  border:1px solid #9a9a9a;
  color: #626262;
  background: transparent;
  border-radius:4px;
}
.miw-100{
  min-width:100%
}
.divider{
  border-top:1px solid var(--divider);
  width:100%;
  margin: 0.5em auto;
  opacity:1;
}


#dark-btn{
  position:absolute;
  top:20px;
  right:20px;
  background:#ccc;
  width:45px;
  border-radius: 15px;
  padding:3p 3px;
  cursor: pointer;
  display:flex;
  transition: padding-left 0.5s, background 0.5s;
}
#dark-btn span{
  width:18px;
  height:18px;
  background:var(--bg-color);
  border-radius: 50%;
  display: inline-block;

}

#dark-btn.dark-btn-on{
  padding-left:23px;
  background:#0a0a0a;

}
.sidebar-footer{
  background-color: var(--body-bg-color);
}
.sidebar-footer .list-group .list-group-item{
  padding:0;
  border:none;
  background:none;
}

.fs-1vw{
  font-size:1.4vw!important
}
.fs-2vw{
  font-size:2.5vw!important
}
#main .sticky-top{
  top:55!important
}

.d-flex-mi{
  display:inline-flex!important;
  align-items: center;
}

.card-rounded-top{
  border-radius: var(--bs-card-border-radius) var(--bs-card-border-radius) 0 0!important;
}

.ck.ck-editor__main>.ck-editor__editable{
  background-color: var(--bs-bw-color)!important;
}
.ck-reset_all :not(.ck-reset_all-excluded *), .ck.ck-reset_all{
  color: var(--bs-wb-color)!important;
}

.ck.ck-toolbar{
  background-color: var(--bs-bw-color)!important;
}
.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused) {
  border-color: #b4b4b4!important;
}

.btn-bw{
  color:var(--bs-wb-color)!important;
  background-color: var(--bs-bw-color)!important;
}
.btn-bw:hover{
  color:#fff!important;
  background-color:var(--bs-primary)!important
}

#sidebar .list-group{
  max-height: 63vh;
  /* margin-bottom: 10px; */
  overflow:hidden;
}

#sidebar .sidebar-left, #rsidebar{
  overflow:hidden;
}
#sidebar .sidebar-left:hover, #rsidebar:hover{
  overflow-y: auto;
  overflow-x:hidden;
}
#sidebar .list-group:hover{
  overflow-y: auto;
  overflow-x:hidden;
}

.custom-scrollbar-js,
.custom-scrollbar-css {
  height: 200px;

}


/* Custom Scrollbar using CSS */
.custom-scrollbar-css {
  overflow-y: scroll;
}

/* scrollbar width */
.custom-scrollbar-css::-webkit-scrollbar {
  width: 3px!important;
}

/* scrollbar track */
.custom-scrollbar-css::-webkit-scrollbar-track {
  background: var(--bs-dark);
}

/* scrollbar handle */
.custom-scrollbar-css::-webkit-scrollbar-thumb {
  border-radius: 1rem;
  background-color: #e30613;
  background-image: linear-gradient(to top, #ff0000 0%, #a8000b 100%);
}

@media only screen and (min-width: 600px) {
  .lsbar{
      left:-235px;
  }
  .header {
      margin-left:0;
  }
  .main{
      margin-left:0;
  }
}
@media only screen and (min-width: 1200px) {
  .lsbar{
      left:0px;
  }
  .header {
      margin-left:235px;
  }
}

@media only screen and (max-width: 600px) {
  .header {
      margin-left:0;
  }
  .main{
      margin-left:0;
  }
  .lsbar{
      left:-235px;
  }

  .border-0-sm {
      border:0!important;
  }
}

/*Profile card 2*/
.profile-card-2 .card-img-block{
  float:left;
  width:100%;
  height:150px;
  overflow:hidden;
}
.profile-card-2 .card-body{
  position:relative;
}
.card .profile {
  position: absolute;
  top: 110px;
  left: 15%;
  max-width: 75px;
  /* border: 3px solid rgba(255, 255, 255, 1); */
  transform: translate(-50%, 0%);
}
.profile-card-2 h5{
  font-weight:600;
  color:#6ab04c;
}
.profile-card-2 .card-text{
  font-weight:300;
  font-size:15px;
}
.profile-card-2 .icon-block{
  float:left;
  width:100%;
}
.profile-card-2 .icon-block a{
  text-decoration:none;
}
.profile-card-2 i {
  display: inline-block;
  font-size: 16px;
  color: #6ab04c;
  text-align: center;
  border: 1px solid #6ab04c;
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 50%;
  margin:0 5px;
}
.profile-card-2 i:hover {
  background-color:#6ab04c;
  color:#fff;
}

.counter {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0.1rem;
}
.month {
  font-size: 18px;
}

/*  avatar css start*/
.avatar-size-120{
  width: 120px!important;
  height: 120px!important
}
.avatar-size-50{
  width: 50px!important;
  height: 50px!important;
}
.avatar-size-40{
  width: 40px!important;
  height: 40px!important;
}
.avatar-size-30{
  width: 30px!important;
  height: 30px!important;
}

.avatar-container {
  position: relative;
}
.avatar-container img {
  height: 100%;
  width: 100%;
  border-radius: 50%;
}
.avatar-container span.initial{
  border-radius:50%;
  border: 1px solid var(--bs-gray-500);
  background-color:#e30613;
  font-size:20px;
  font-weight:700;
  color:#fff;
  display:flex;
  justify-content: center;
  align-items: center;
}
.avatar-container .online{
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: #17ca28;
  border: 2px solid white;
  top: 0;
  right: 0;
  position: absolute;
}
/* avatar css end */


.avatar-30 img{
  border: 1px solid var(--bs-gray-500);
  width: 30px;
  height: 30px;
}
.avatar-30 span.initial{
  border-radius:50%;
  text-transform:capitalize;
  border: 1px solid var(--bs-gray-500);
  min-width: 30px;
  height: 30px;
  background-color:#e30613;
  font-size:20px;
  font-weight:700;
  color:#fff;
  display:flex;
  justify-content: center;
  align-items: center;
}
/* .avatar-30::before {
box-shadow: 0 0 0 1px #fff; 
position: absolute;
width:6px;
height:6px;
left: 24px;
top: 4px;
content: "";
font-size:2rem;
border-radius: 100%;
background-color: #17ca28;
z-index: 100;
opacity: 0;
visibility: visible;  
} */

.avatar-30-active img{
  border: 1px solid var(--bs-gray-500);
  width: 30px;
  height: 30px;
}
.avatar-30-active span.initial{
  border-radius:50%;
  text-transform:capitalize;
  border: 1px solid var(--bs-gray-500);
  min-width: 30px;
  height: 30px;
  background-color:#e30613;
  font-size:20px;
  font-weight:700;
  color:#fff;
  display:flex;
  justify-content: center;
  align-items: center;
}
.avatar-30-active::before {
  box-shadow: 0 0 0 1px #fff;
  position: absolute;
  width:6px;
  height:6px;
  left: 24px;
  top: 4px;
  content: "";
  font-size:2rem;
  border-radius: 100%;
  background-color: #17ca28;
  z-index: 100;
  opacity: 1;
  visibility: visible;
}

.avatar-40 img{
  border: 1px solid var(--bs-gray-500);
  width: 40px;
  height: 40px;
}
.avatar-40 span.initial{
  border-radius:50%;
  text-transform:capitalize;
  border: 1px solid var(--bs-gray-500);
  min-width: 40px;
  height: 40px;
  background-color:#e30613;
  font-size:20px;
  font-weight:700;
  color:#fff;
  display:flex;
  justify-content: center;
  align-items: center;
}
/* .avatar-40::before {
box-shadow: 0 0 0 1.5px #fff; 
position: absolute;
width:9px;
height:9px;
left: 32px;
top: 2px;
content: "";
font-size:2rem;
border-radius: 100%;
background-color: #17ca28;
z-index: 100;
opacity: 1;
visibility: visible;
} */

.avatar-40-active img{
  border: 1px solid var(--bs-gray-500);
  width: 40px;
  height: 40px;
}
.avatar-40-active span.initial{
  border-radius:50%;
  text-transform:capitalize;
  border: 1px solid var(--bs-gray-500);
  min-width: 40px;
  height: 40px;
  background-color:#e30613;
  font-size:20px;
  font-weight:700;
  color:#fff;
  display:flex;
  justify-content: center;
  align-items: center;
}
.avatar-40-active::before {
  box-shadow: 0 0 0 1.5px #fff;
  position: absolute;
  width:9px;
  height:9px;
  left: 32px;
  top: 2px;
  content: "";
  font-size:2rem;
  border-radius: 100%;
  background-color: #17ca28;
  z-index: 100;
  opacity: 1;
  visibility: visible;
}

.avatar-50 img{
  border: 1px solid var(--bs-gray-500);
  width: 50px;
  height: 50px;
}
.avatar-50 span.initial{
  border-radius:50%;
  text-transform:capitalize;
  border: 1px solid var(--bs-gray-500);
  min-width: 50px;
  height: 50px;
  background-color:#e30613;
  font-size:20px;
  font-weight:700;
  color:#fff;
  display:flex;
  justify-content: center;
  align-items: center;
}
/* .avatar-50::before {
box-shadow: 0 0 0 1.5px #fff; 
position: absolute;
width:9px;
height:9px;
left: 47px;
top: 15px;
content: "";
border-radius: 100%;
background-color: #17ca28;
z-index: 100;
opacity: 0;
visibility: visible;
} */


.avatar-50-active img{
  border: 1px solid var(--bs-gray-500);
  width: 50px;
  height: 50px;
}
.avatar-50-active span.initial{
  border-radius:50%;
  text-transform:capitalize;
  border: 1px solid var(--bs-gray-500);
  min-width: 50px;
  height: 50px;
  background-color:#e30613;
  font-size:20px;
  font-weight:700;
  color:#fff;
  display:flex;
  justify-content: center;
  align-items: center;
}
.avatar-50-active::before {
  box-shadow: 0 0 0 1.5px #fff;
  position: absolute;
  width:9px;
  height:9px;
  left: 47px;
  top: 15px;
  content: "";
  border-radius: 100%;
  background-color: #17ca28;
  z-index: 100;
  opacity: 1;
  visibility: visible;
}

.avatar-120 img{
  border: 1px solid var(--bs-gray-500);
  width: 120px;
  height: 120px;
}
.avatar-120 span.initial{
  border-radius:50%;
  text-transform:capitalize;
  border: 1px solid var(--bs-gray-500);
  min-width: 120px;
  height: 120px;
  background-color:#e30613;
  font-size:50px;
  font-weight:700;
  color:#fff;
  display:flex;
  justify-content: center;
  align-items: center;
}
/* .avatar-120::before {
position: absolute;
border:1px solid #fff;
width:15px;
height:15px;
left: 115px;
top: 30px;
content: "";
border-radius: 100%;
background-color: #17ca28;
z-index: 100;
opacity: 0;
visibility: visible;
} */
.avatar-120-active img{
  border: 1px solid var(--bs-gray-500);
  width: 120px;
  height: 120px;
}
.avatar-120-active span.initial{
  border-radius:50%;
  text-transform:capitalize;
  border: 1px solid var(--bs-gray-500);
  min-width: 120px;
  height: 120px;
  background-color:#e30613;
  font-size:50px;
  font-weight:700;
  color:#fff;
  display:flex;
  justify-content: center;
  align-items: center;
}
.avatar-120-active::before {
  position: absolute;
  border:1px solid #fff;
  width:15px;
  height:15px;
  left: 115px;
  top: 30px;
  content: "";
  border-radius: 100%;
  background-color: #17ca28;
  z-index: 100;
  opacity: 1;
  visibility: visible;
}
.user-avatar {
  width: 50px;
  height: 50px;
  border-radius: 100%;
  background-size: cover;
  background-position: 50% 50%;
  position: relative;
  border: 0.5px solid var(--bordercolor);
}

[placeholder]:focus::-webkit-input-placeholder {
  color: transparent;
}
[placeholder]:focus::-webkit-input-placeholder {
  -webkit-transition: opacity 0.5s 0.5s ease;
  transition: opacity 0.5s 0.5s ease;
  opacity: 0;
}

.copyright{
  line-height: 1!important;
}
.mention{
  text-decoration: underline;
  color:#e10613;
  cursor:pointer;
}


#dd-notification .dropdown-toggle::after {
  display: none !important; 
}`, "",{"version":3,"sources":["webpack://./src/assets/css/style2.css"],"names":[],"mappings":";AACA;EACE,6DAA6D;EAC7D,qCAAqC;EACrC,qCAAqC;EACrC,uBAAuB;EACvB,gCAAgC;;AAElC;;AAEA;;;;;;;;;GASG;;AAEH;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;AACnB;;;AAGA;EACE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;;;AAIA;;+DAE+D;AAC/D;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,2BAA2B;;AAE7B;;AAEA;EACE;MACI,aAAa;EACjB;AACF;;AAEA;;+DAE+D;AAC/D;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;+DAE+D;AAC/D;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA4BG;;AAEH;;+DAE+D;AAC/D,mBAAmB;AACnB;EACE,kBAAkB;EAClB,eAAe;EAEf,gCAAgC;EAEhC,wBAAwB;EAExB,yBAAyB;EACzB,SAAS;EACT,+CAA+C;AACjD;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE;MACI,WAAW;MACX,WAAW;MACX,YAAY;MACZ,+BAA+B;MAC/B,kBAAkB;MAClB,SAAS;MACT,WAAW;MACX,wBAAwB;MACxB,0BAA0B;MAC1B,2BAA2B;EAC/B;AACF;;AAiBA;EACE;MACI,UAAU;EACd;;EAEA;MACI,UAAU;EACd;;EAEA;MACI,UAAU;EACd;AACF;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,SAAS;AACT;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;;EAEE,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA,cAAc;AACd;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA6BG;;AAEH,gBAAgB;AAChB;EACE,eAAe;EACf,yCAAyC;EACzC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;;GAEG;;AAEH;;;;GAIG;;AAEH;;;GAGG;;AAEH;;;;GAIG;;AAEH;;+DAE+D;AAC/D;EACE,cAAc;AAChB;;AAEA;EACE;MACI,YAAY;EAChB;AACF;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qDAAqD;AACvD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,gDAAgD;EAChD,qDAAqD;EACrD,sCAAsC;EACtC,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,OAAO;;AAET;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;MACI,eAAe;MACf,SAAS;MACT,OAAO;MACP,QAAQ;MACR,aAAa;MACb,kDAAkD;MAClD,iBAAiB;MACjB,aAAa;MACb,gBAAgB;MAChB,kBAAkB;MAClB,UAAU;EACd;;EAEA;MACI,SAAS;MACT,mBAAmB;MACnB,UAAU;EACd;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,2BAA2B;EAC3B,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gCAAgC;AAClC;;AAEA;;EAEE,aAAa;EACb,6CAA6C;EAC7C,uCAAuC;AACzC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;+DAE+D;AAC/D;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;+DAE+D;AAC/D;EACE,oBAAoB;EACpB,eAAe;EACf,MAAM;EACN,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf;;;mDAGiD;EACjD,8CAA8C;EAC9C,sCAAsC;AACxC;;AAEA;EACE,MAAM;EACN,oBAAoB;AACtB;AACA;EACE,OAAO;EACP,oBAAoB;AACtB;;AAEA;EACE;MACI,YAAY;EAChB;AACF;;AAEA;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE;;MAEI,kBAAkB;MAClB,kBAAkB;EACtB;AACF;;AAEA;EACE;MACI,OAAO;EACX;AACF;;AAEA;;EAEE;;MAEI,cAAc;EAClB;;EAEA;MACI,YAAY;EAChB;AACF;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;+DAE+D;AAC/D,oBAAoB;AACpB;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,MAAM;EACN,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,UAAU;EACV,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;+DAE+D;AAC/D;EACE,aAAa;EACb,eAAe;EACf,2DAA2D;EAC3D,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;+DAE+D;AAC/D;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,4BAA4B;EAC5B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;+DAE+D;AAC/D;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;+DAE+D;AAC/D;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EAEtB,6CAA6C;AAC/C;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAYA;EACE;MACI,uBAAuB;EAC3B;;EAEA;MACI,yBAAyB;EAC7B;AACF;;AAEA;;+DAE+D;AAC/D;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;MACI,cAAc;EAClB;AACF;;AAEA;;+DAE+D;AAC/D;EACE,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA,qBAAqB;AACrB;EACE,WAAW;EACX,gCAAgC;EAChC,wBAAwB;EACxB,aAAa;EACb,cAAc;AAChB;AACA;EACE,UAAU;EACV,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,wBAAwB;EACxB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;EACT,4BAA4B;EAC5B,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,qBAAqB;;AAEvB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,UAAU;EACV,iBAAiB;;AAEnB;AACA;EACE,aAAa;EACb,aAAa;EACb,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE;AACF;AACA;EACE,mCAAmC;EACnC,UAAU;EACV,kBAAkB;EAClB,SAAS;AACX;;;AAGA;EACE,iBAAiB;EACjB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,8CAA8C;AAChD;AACA;EACE,UAAU;EACV,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,qBAAqB;;AAEvB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;;AAEpB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;AACF;AACA;EACE;AACF;AACA;EACE;AACF;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,sFAAsF;AACxF;;AAEA;EACE,8CAA8C;AAChD;AACA;EACE,mCAAmC;AACrC;;AAEA;EACE,8CAA8C;AAChD;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,8CAA8C;AAChD;AACA;EACE,oBAAoB;EACpB;AACF;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;;AAEf;;;AAGA,+BAA+B;AAC/B;EACE,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;AACtB;;AAEA,oBAAoB;AACpB;EACE,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mEAAmE;AACrE;;AAEA;EACE;MACI,WAAW;EACf;EACA;MACI,aAAa;EACjB;EACA;MACI,aAAa;EACjB;AACF;AACA;EACE;MACI,QAAQ;EACZ;EACA;MACI,iBAAiB;EACrB;AACF;;AAEA;EACE;MACI,aAAa;EACjB;EACA;MACI,aAAa;EACjB;EACA;MACI,WAAW;EACf;;EAEA;MACI,kBAAkB;EACtB;AACF;;AAEA,iBAAiB;AACjB;EACE,UAAU;EACV,UAAU;EACV,YAAY;EACZ,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,eAAe;EACf,8CAA8C;EAE9C,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,aAAa;AACf;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,sBAAsB;EACtB;AACF;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,wBAAwB;EACxB,cAAc;EACd,eAAe;EACf,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,MAAM;EACN,QAAQ;EACR,kBAAkB;AACpB;AACA,mBAAmB;;;AAGnB;EACE,oCAAoC;EACpC,WAAW;EACX,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,oCAAoC;EACpC,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB,cAAc;EACd,eAAe;EACf,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;;;;;;;;;;;;;GAcG;;AAEH;EACE,oCAAoC;EACpC,WAAW;EACX,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,oCAAoC;EACpC,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB,cAAc;EACd,eAAe;EACf,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,QAAQ;EACR,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,oCAAoC;EACpC,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB,cAAc;EACd,eAAe;EACf,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;;;;;;;;;;;;;GAcG;;AAEH;EACE,oCAAoC;EACpC,WAAW;EACX,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,oCAAoC;EACpC,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB,cAAc;EACd,eAAe;EACf,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,QAAQ;EACR,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,oCAAoC;EACpC,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB,cAAc;EACd,eAAe;EACf,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;;;;;;;;;;;;GAaG;;;AAGH;EACE,oCAAoC;EACpC,WAAW;EACX,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,oCAAoC;EACpC,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB,cAAc;EACd,eAAe;EACf,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,oCAAoC;EACpC,gBAAgB;EAChB,aAAa;EACb,wBAAwB;EACxB,cAAc;EACd,eAAe;EACf,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;;;;;;;;;;;;GAaG;AACH;EACE,oCAAoC;EACpC,YAAY;EACZ,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,oCAAoC;EACpC,gBAAgB;EAChB,aAAa;EACb,wBAAwB;EACxB,cAAc;EACd,eAAe;EACf,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,WAAW;EACX,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,0CAAkC;EAAlC,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,0BAA0B;EAC1B,aAAa;EACb,cAAc;AAChB;;;AAGA;EACE,wBAAwB;AAC1B","sourcesContent":["\n:root {\n  --bs-font-sans-serif: \"Barlow Regular\" , sans-serif!important;\n  --bs-btn-padding-x: 0.55rem!important;\n  --bs-btn-padding-y: 0.15rem!important;\n  scroll-behavior: smooth;\n  scrollbar-width: thin !important;\n\n}\n\n/* .dark-theme{\n  --body-color:#999;\n  --nav-color: #fff;\n  --bg-color: #333;\n      --dark: #ff771d;\n      --body-bg-color:#000;\n      --divider: #333;\n      --hdr-shadow: rgba(255, 255, 255, 0.25);\n      --bs-accordion-btn-color:#fff;\n} */\n\n.main-content {\n  width: calc(100% - 255px);\n  float: left;\n  min-height: 950px;\n}\n\n\na {\n  text-decoration: none!important;\n}\n\na:hover {\n  text-decoration: none;\n}\n\n\n\n/*--------------------------------------------------------------\n# Main\n--------------------------------------------------------------*/\n#main {\n  margin-top: 0;\n  padding: 20px 0;\n  transition: all 0.3s;\n  /*  border:1px solid #000;*/\n\n}\n\n@media (max-width: 1199px) {\n  #main {\n      padding: 20px;\n  }\n}\n\n/*--------------------------------------------------------------\n# Page Title\n--------------------------------------------------------------*/\n.pagetitle {\n  margin-bottom: 10px;\n}\n\n.pagetitle h1 {\n  font-size: 24px;\n  margin-bottom: 0;\n  font-weight: 600;\n}\n\n/*--------------------------------------------------------------\n# Back to top button\n--------------------------------------------------------------*/\n/* .back-to-top {\nposition: fixed;\nvisibility: hidden;\nopacity: 0;\nright: 15px;\nbottom: 15px;\nz-index: 99999;\nbackground: #4154f1;\nwidth: 40px;\nheight: 40px;\nborder-radius: 4px;\ntransition: all 0.4s;\n}\n\n.back-to-top i {\nfont-size: 24px;\ncolor: #fff;\nline-height: 0;\n}\n\n.back-to-top:hover {\nbackground: #6776f4;\ncolor: #fff;\n}\n\n.back-to-top.active {\nvisibility: visible;\nopacity: 1;\n} */\n\n/*--------------------------------------------------------------\n# Override some default Bootstrap stylings\n--------------------------------------------------------------*/\n/* Dropdown menus */\n.dropdown-menu {\n  border-radius: 4px;\n  padding: 10px 0;\n  -webkit-animation-name: dropdown-animate;\n  animation-name: dropdown-animate;\n  -webkit-animation-duration: 0.2s;\n  animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n  border: 0;\n  box-shadow: 0 5px 30px 0 rgba(82, 63, 105, 0.2);\n}\n\n.dropdown-menu .dropdown-header,\n.dropdown-menu .dropdown-footer {\n  text-align: center;\n  font-size: 15px;\n  padding: 10px 25px;\n}\n\n.dropdown-menu .dropdown-footer a {\n  color: #444444;\n  text-decoration: underline;\n}\n\n.dropdown-menu .dropdown-footer a:hover {\n  text-decoration: none;\n}\n\n.dropdown-menu .dropdown-divider {\n  color: #8d8d8d;\n  margin: 0;\n}\n\n.dropdown-menu .dropdown-item {\n  font-size: 14px;\n  padding: 5px 15px;\n  transition: 0.3s;\n}\n\n.dropdown-menu .dropdown-item i {\n  margin-right: 10px;\n  font-size: 18px;\n  line-height: 0;\n}\n\n.dropdown-menu .dropdown-item:hover {\n  background-color: var(--bs-gray-600);\n  color:#fff;\n}\n\n@media (min-width: 768px) {\n  .dropdown-menu-arrow::before {\n      content: \"\";\n      width: 13px;\n      height: 13px;\n      background: var(--bs-bw2-color);\n      position: absolute;\n      top: -7px;\n      right: 20px;\n      transform: rotate(45deg);\n      border-top: 1px solid #444;\n      border-left: 1px solid #444;\n  }\n}\n\n\n@-webkit-keyframes dropdown-animate {\n  0% {\n      opacity: 0;\n  }\n\n  100% {\n      opacity: 1;\n  }\n\n  0% {\n      opacity: 0;\n  }\n}\n\n@keyframes dropdown-animate {\n  0% {\n      opacity: 0;\n  }\n\n  100% {\n      opacity: 1;\n  }\n\n  0% {\n      opacity: 0;\n  }\n}\n\n/* Light Backgrounds */\n.bg-primary-light {\n  background-color: #cfe2ff;\n  border-color: #cfe2ff;\n}\n\n.bg-secondary-light {\n  background-color: #e2e3e5;\n  border-color: #e2e3e5;\n}\n\n.bg-success-light {\n  background-color: #d1e7dd;\n  border-color: #d1e7dd;\n}\n\n.bg-danger-light {\n  background-color: #f8d7da;\n  border-color: #f8d7da;\n}\n\n.bg-warning-light {\n  background-color: #fff3cd;\n  border-color: #fff3cd;\n}\n\n.bg-info-light {\n  background-color: #cff4fc;\n  border-color: #cff4fc;\n}\n\n.bg-dark-light {\n  background-color: #d3d3d4;\n  border-color: #d3d3d4;\n}\n\n/* Card */\n.card {\n  margin-bottom: 30px;\n  border: none;\n  border-radius: 5px;\n  box-shadow: 0px 0 30px rgba(1, 41, 112, 0.1);\n  /* min-height:100px; */\n}\n\n.card-header,\n.card-footer {\n  border-color: #ebeef4;\n  background-color: #fff;\n  color: #798eb3;\n  padding: 15px;\n}\n\n.card-title {\n  padding: 10px 0 0 0;\n  font-size: 18px;\n  font-weight: 500;\n  color: var(--bs-link-color);\n}\n\n.card-title span {\n  color: #000000;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.card-body {\n  padding: 0 20px 20px 20px;\n}\n\n.card-img-overlay {\n  background-color: rgba(0, 0, 0, 0.25);\n}\n\n/* Alerts */\n.alert-heading {\n  font-weight: 500;\n  font-family: \"Barlow Regular\", sans-serif;\n  font-size: 20px;\n}\n\n/* Close Button */\n.btn-close {\n  background-size: 25%;\n}\n\n.btn-close:focus {\n  outline: 0;\n  box-shadow: none;\n}\n\n/* Accordion */\n/* .accordion-item {\nborder: 1px solid #ebeef4;\n}\n\n.accordion-button:focus {\noutline: 0;\nbox-shadow: none;\n}\n\n.accordion-button:not(.collapsed) {\ncolor: var(--nav-color);\nbackground-color: var(--bg-color);\n}\n\n.accordion-flush .accordion-button {\npadding: 15px 0;\nbackground: none;\nborder: 0;\n}\n\n.accordion-flush .accordion-button:not(.collapsed) {\nbox-shadow: none;\ncolor: #4154f1;\n}\n\n.accordion-flush .accordion-body {\npadding: 0 0 15px 0;\ncolor: #3e4f6f;\nfont-size: 15px;\n} */\n\n/* Breadcrumbs */\n.breadcrumb {\n  font-size: 14px;\n  font-family: \"Barlow Regular\", sans-serif;\n  color: #899bbd;\n  font-weight: 600;\n}\n\n.breadcrumb a {\n  color: #899bbd;\n  transition: 0.3s;\n}\n\n.breadcrumb a:hover {\n  color: #51678f;\n}\n\n.breadcrumb .breadcrumb-item::before {\n  color: #899bbd;\n}\n\n.breadcrumb .active {\n  color: #51678f;\n  font-weight: 600;\n}\n\n/* Bordered Tabs */\n/* .nav-tabs-bordered {\nborder-bottom: 2px solid #ebeef4;\n} */\n\n/* .nav-tabs-bordered .nav-link {\nmargin-bottom: -2px;\nborder: none;\ncolor: #2c384e;\n} */\n\n/* .nav-tabs-bordered .nav-link:hover,\n.nav-tabs-bordered .nav-link:focus {\ncolor: #4154f1;\n} */\n\n/* .nav-tabs-bordered .nav-link.active {\nbackground-color: #fff;\ncolor: #4154f1;\nborder-bottom: 2px solid #4154f1;\n} */\n\n/*--------------------------------------------------------------\n# Header\n--------------------------------------------------------------*/\n.logo {\n  line-height: 1;\n}\n\n@media (min-width: 1200px) {\n  .logo {\n      width: 280px;\n  }\n}\n#sidebar .logo {\n  padding: 0px;\n  /* text-align: left; */\n  width: 100%;\n}\n.logo img {\n  max-height: 70px;\n  margin-right: 6px;\n  /* filter:brightness(var(--logo-filter))!important; */\n}\n\n.logo span {\n  font-size: 26px;\n  font-weight: 700;\n  color: #012970;\n  font-family: \"Barlow Regular\", sans-serif;\n}\n\n.header {\n  transition: all 0.5s;\n  z-index: 997;\n  height: 60px;\n  /* box-shadow: 0px 1px 3px var(--bs-gray-500); */\n  /* border-bottom: 2px solid var(--bs-border-color); */\n  background-color: var(--body-bg-color);\n  padding-left: 20px;\n  /* position:absolute; */\n  margin-left:236px;\n  /* Toggle Sidebar Button */\n  /* Search Bar */\n  right:0;\n\n}\n\n.header .toggle-sidebar-btn {\n  font-size: 32px;\n  padding-left: 10px;\n  cursor: pointer;\n  color: var(--bs-light);\n}\n\n.header .search-bar {\n  min-width: 360px;\n  padding: 0 20px;\n}\n\n@media (max-width: 1199px) {\n  .header .search-bar {\n      position: fixed;\n      top: 50px;\n      left: 0;\n      right: 0;\n      padding: 20px;\n      box-shadow: 0px 0px 15px 0px rgba(1, 41, 112, 0.1);\n      background: white;\n      z-index: 9999;\n      transition: 0.3s;\n      visibility: hidden;\n      opacity: 0;\n  }\n\n  .header .search-bar-show {\n      top: 60px;\n      visibility: visible;\n      opacity: 1;\n  }\n}\n\n.header .search-form {\n  width: 100%;\n}\n\n.header .search-form input {\n  border: 0;\n  font-size: 14px;\n  /*color: var(--bg-color); */\n  /* border: 1px solid var(--bs-gray-300); */\n  padding: 7px 38px 7px 8px;\n  border-radius: 3px;\n  transition: 0.3s;\n  width: 100%;\n  background: var(--body-bg-color);\n}\n\n.header .search-form input:focus,\n.header .search-form input:hover {\n  outline: none;\n  box-shadow: 0 0 10px 0 rgba(1, 41, 112, 0.15);\n  border: 1px solid rgba(1, 41, 112, 0.3);\n}\n\n.header .search-form button {\n  border: 0;\n  padding: 0;\n  margin-left: -30px;\n  background: none;\n}\n\n.header .search-form button i {\n  color: var(--bg-color);\n}\n\n/*--------------------------------------------------------------\n# Header Nav\n--------------------------------------------------------------*/\n.header-nav ul {\n  list-style: none;\n}\n\n.header-nav>ul {\n  margin: 0;\n  padding: 0;\n}\n\n.header-nav .nav-icon {\n  font-size: 22px;\n  color: var(--nav-color);\n  margin-right: 5px;\n  position: relative;\n}\n\n.header-nav .nav-profile {\n  color: var(--nav-color);\n}\n\n.header-nav .nav-profile img {\n  max-height: 40px;\n}\n\n.header-nav .nav-profile span {\n  font-size: 14px;\n  /* font-weight: 600; */\n}\n\n.header-nav .badge-number {\n  position: absolute;\n  inset: -2px -5px auto auto;\n  font-weight: normal;\n  font-size: 12px;\n  padding: 3px 6px;\n}\n.header-nav .badge-online {\n  position: absolute;\n  inset: -2px -5px auto auto;\n  font-weight: normal;\n  font-size: 12px;\n  padding: 3px 3px;\n}\n\n.header-nav .notifications {\n  inset: 8px -15px auto auto !important;\n}\n\n.header-nav .notifications .notification-item {\n  display: flex;\n  align-items: center;\n  padding: 15px 10px;\n  transition: 0.3s;\n}\n\n.header-nav .notifications .notification-item i {\n  margin: 0 20px 0 10px;\n  font-size: 24px;\n}\n\n.header-nav .notifications .notification-item h4 {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 5px;\n}\n\n.header-nav .notifications .notification-item p {\n  font-size: 13px;\n  margin-bottom: 3px;\n  color: #919191;\n}\n\n.header-nav .notifications .notification-item:hover {\n  background-color: #f6f9ff;\n}\n\n.header-nav .messages {\n  inset: 8px -15px auto auto !important;\n}\n\n.header-nav .messages .message-item {\n  padding: 15px 10px;\n  transition: 0.3s;\n}\n\n.header-nav .messages .message-item a {\n  display: flex;\n}\n\n.header-nav .messages .message-item img {\n  margin: 0 20px 0 10px;\n  max-height: 40px;\n}\n\n.header-nav .messages .message-item h4 {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 5px;\n  color: #444444;\n}\n\n.header-nav .messages .message-item p {\n  font-size: 13px;\n  margin-bottom: 3px;\n  color: #919191;\n}\n\n.header-nav .messages .message-item:hover {\n  background-color: #f6f9ff;\n}\n\n.header-nav .profile {\n  min-width: 240px;\n  padding-bottom: 0;\n  top: 8px !important;\n}\n\n.header-nav .profile .dropdown-header h6 {\n  font-size: 18px;\n  margin-bottom: 0;\n  font-weight: 600;\n}\n\n.header-nav .profile .dropdown-header span {\n  font-size: 14px;\n}\n\n.header-nav .profile .dropdown-item {\n  font-size: 14px;\n  padding: 10px 15px;\n  transition: 0.3s;\n}\n\n.header-nav .profile .dropdown-item i {\n  margin-right: 10px;\n  font-size: 18px;\n  line-height: 0;\n}\n\n.header-nav .profile .dropdown-item:hover {\n  /* background-color: var(--bg-color); */\n}\n\n/*--------------------------------------------------------------\n# Sidebar\n--------------------------------------------------------------*/\n.sidebar {\n  transition: all 0.3s;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  width: 235px;\n  z-index: 996;\n  padding: 20px 7px;\n  overflow:hidden;\n  /* overflow-y: auto;\n  overflow-x:hidden;\n  scrollbar-width: thin;\n  scrollbar-color: var(--body-color) transparent; */\n  box-shadow: 0px 0px 20px rgba(1, 41, 112, 0.1);\n  background-color: var(--body-bg-color);\n}\n\n.lsbar{\n  left:0;\n  transition: all 0.3s;\n}\n.rsbar{\n  right:0;\n  transition: all 0.3s;\n}\n\n@media (max-width: 1199px) {\n  .sidebar {\n      left: -275px;\n  }\n}\n\n.sidebar::-webkit-scrollbar {\n  width: 5px;\n  height: 8px;\n  background-color: #fff;\n}\n\n.sidebar::-webkit-scrollbar-thumb {\n  background-color: #aab7cf;\n}\n\n@media (min-width: 1200px) {\n\n  #main,\n  #footer {\n      margin-left: 240px;\n      margin-right:240px;\n  }\n}\n\n@media (max-width: 1199px) {\n  .toggle-sidebar .sidebar {\n      left: 0;\n  }\n}\n\n@media (min-width: 1200px) {\n\n  .toggle-sidebar #main,\n  .toggle-sidebar #footer {\n      margin-left: 0;\n  }\n\n  .toggle-sidebar .sidebar {\n      left: -300px;\n  }\n}\n\n.sidebar-nav {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\n.sidebar-nav li {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n.sidebar-nav .nav-item {\n  margin-bottom: 0px;\n}\n\n.sidebar-nav .nav-heading {\n  font-size: 11px;\n  text-transform: uppercase;\n  color: #899bbd;\n  font-weight: 600;\n  margin: 10px 0 5px 15px;\n}\n\n.sidebar-nav .nav-link {\n  display: flex;\n  align-items: center;\n  font-size: 15px;\n  font-weight: 600;\n  color: #4154f1;\n  transition: 0.3;\n  background: #f6f9ff;\n  padding: 10px 15px;\n  border-radius: 4px;\n}\n\n.sidebar-nav .nav-link i {\n  font-size: 16px;\n  margin-right: 10px;\n  color: #4154f1;\n}\n\n.sidebar-nav .nav-link.collapsed {\n  color: #012970;\n  background: #fff;\n}\n\n.sidebar-nav .nav-link.collapsed i {\n  color: #899bbd;\n}\n\n.sidebar-nav .nav-link:hover {\n  color: #4154f1;\n  background: #f6f9ff;\n}\n\n.sidebar-nav .nav-link:hover i {\n  color: #4154f1;\n}\n\n.sidebar-nav .nav-link .bi-chevron-down {\n  margin-right: 0;\n  transition: transform 0.2s ease-in-out;\n}\n\n.sidebar-nav .nav-link:not(.collapsed) .bi-chevron-down {\n  transform: rotate(180deg);\n}\n\n.sidebar-nav .nav-content {\n  padding: 5px 0 0 0;\n  margin: 0;\n  list-style: none;\n}\n\n.sidebar-nav .nav-content a {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  font-weight: 600;\n  color: #012970;\n  transition: 0.3;\n  padding: 10px 0 10px 40px;\n  transition: 0.3s;\n}\n\n.sidebar-nav .nav-content a i {\n  font-size: 6px;\n  margin-right: 8px;\n  line-height: 0;\n  border-radius: 50%;\n}\n\n.sidebar-nav .nav-content a:hover,\n.sidebar-nav .nav-content a.active {\n  color: #4154f1;\n}\n\n.sidebar-nav .nav-content a.active i {\n  background-color: #4154f1;\n}\n\n/*--------------------------------------------------------------\n# Dashboard\n--------------------------------------------------------------*/\n/* Filter dropdown */\n.dashboard .filter {\n  position: absolute;\n  right: 0px;\n  top: 15px;\n}\n\n.dashboard .filter .icon {\n  color: #aab7cf;\n  padding-right: 20px;\n  padding-bottom: 5px;\n  transition: 0.3s;\n  font-size: 16px;\n}\n\n.dashboard .filter .icon:hover,\n.dashboard .filter .icon:focus {\n  color: #4154f1;\n}\n\n.dashboard .filter .dropdown-header {\n  padding: 8px 15px;\n}\n\n.dashboard .filter .dropdown-header h6 {\n  text-transform: uppercase;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 1px;\n  color: #aab7cf;\n  margin-bottom: 0;\n  padding: 0;\n}\n\n.dashboard .filter .dropdown-item {\n  padding: 8px 15px;\n}\n\n/* Info Cards */\n.dashboard .info-card {\n  padding-bottom: 10px;\n}\n\n.dashboard .info-card h6 {\n  font-size: 28px;\n  color: #012970;\n  font-weight: 700;\n  margin: 0;\n  padding: 0;\n}\n\n.dashboard .card-icon {\n  font-size: 32px;\n  line-height: 0;\n  width: 64px;\n  height: 64px;\n  flex-shrink: 0;\n  flex-grow: 0;\n}\n\n.dashboard .sales-card .card-icon {\n  color: #4154f1;\n  background: #f6f6fe;\n}\n\n.dashboard .revenue-card .card-icon {\n  color: #2eca6a;\n  background: #e0f8e9;\n}\n\n.dashboard .customers-card .card-icon {\n  color: #ff771d;\n  background: #ffecdf;\n}\n\n/* Activity */\n.dashboard .activity {\n  font-size: 14px;\n}\n\n.dashboard .activity .activity-item .activite-label {\n  color: #888;\n  position: relative;\n  flex-shrink: 0;\n  flex-grow: 0;\n  min-width: 64px;\n}\n\n.dashboard .activity .activity-item .activite-label::before {\n  content: \"\";\n  position: absolute;\n  right: -11px;\n  width: 4px;\n  top: 0;\n  bottom: 0;\n  background-color: #eceefe;\n}\n\n.dashboard .activity .activity-item .activity-badge {\n  margin-top: 3px;\n  z-index: 1;\n  font-size: 11px;\n  line-height: 0;\n  border-radius: 50%;\n  flex-shrink: 0;\n  border: 3px solid #fff;\n  flex-grow: 0;\n}\n\n.dashboard .activity .activity-item .activity-content {\n  padding-left: 10px;\n  padding-bottom: 20px;\n}\n\n.dashboard .activity .activity-item:first-child .activite-label::before {\n  top: 5px;\n}\n\n.dashboard .activity .activity-item:last-child .activity-content {\n  padding-bottom: 0;\n}\n\n/* News & Updates */\n.dashboard .news .post-item+.post-item {\n  margin-top: 15px;\n}\n\n.dashboard .news img {\n  width: 80px;\n  float: left;\n  border-radius: 5px;\n}\n\n.dashboard .news h4 {\n  font-size: 15px;\n  margin-left: 95px;\n  font-weight: bold;\n  margin-bottom: 5px;\n}\n\n.dashboard .news h4 a {\n  color: #012970;\n  transition: 0.3s;\n}\n\n.dashboard .news h4 a:hover {\n  color: #4154f1;\n}\n\n.dashboard .news p {\n  font-size: 14px;\n  color: #777777;\n  margin-left: 95px;\n}\n\n/* Recent Sales */\n.dashboard .recent-sales {\n  font-size: 14px;\n}\n\n.dashboard .recent-sales .table thead {\n  background: #f6f6fe;\n}\n\n.dashboard .recent-sales .table thead th {\n  border: 0;\n}\n\n.dashboard .recent-sales .dataTable-top {\n  padding: 0 0 10px 0;\n}\n\n.dashboard .recent-sales .dataTable-bottom {\n  padding: 10px 0 0 0;\n}\n\n/* Top Selling */\n.dashboard .top-selling {\n  font-size: 14px;\n}\n\n.dashboard .top-selling .table thead {\n  background: #f6f6fe;\n}\n\n.dashboard .top-selling .table thead th {\n  border: 0;\n}\n\n.dashboard .top-selling .table tbody td {\n  vertical-align: middle;\n}\n\n.dashboard .top-selling img {\n  border-radius: 5px;\n  max-width: 60px;\n}\n\n/*--------------------------------------------------------------\n# Icons list page\n--------------------------------------------------------------*/\n.iconslist {\n  display: grid;\n  max-width: 100%;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 1.25rem;\n  padding-top: 15px;\n}\n\n.iconslist .icon {\n  background-color: #fff;\n  border-radius: 0.25rem;\n  text-align: center;\n  color: #012970;\n  padding: 15px 0;\n}\n\n.iconslist i {\n  margin: 0.25rem;\n  font-size: 2.5rem;\n}\n\n.iconslist .label {\n  font-family: var(--bs-font-monospace);\n  display: inline-block;\n  width: 100%;\n  overflow: hidden;\n  padding: 0.25rem;\n  font-size: 12px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #666;\n}\n\n/*--------------------------------------------------------------\n# Profie Page\n--------------------------------------------------------------*/\n.profile .profile-card img {\n  max-width: 120px;\n}\n\n.profile .profile-card h2 {\n  font-size: 24px;\n  font-weight: 700;\n  color: #2c384e;\n  margin: 10px 0 0 0;\n}\n\n.profile .profile-card h3 {\n  font-size: 18px;\n}\n\n.profile .profile-card .social-links a {\n  font-size: 20px;\n  display: inline-block;\n  color: rgba(1, 41, 112, 0.5);\n  line-height: 0;\n  margin-right: 10px;\n  transition: 0.3s;\n}\n\n.profile .profile-card .social-links a:hover {\n  color: #012970;\n}\n\n.profile .profile-overview .row {\n  margin-bottom: 20px;\n  font-size: 15px;\n}\n\n.profile .profile-overview .card-title {\n  color: #012970;\n}\n\n.profile .profile-overview .label {\n  font-weight: 600;\n  color: rgba(1, 41, 112, 0.6);\n}\n\n.profile .profile-edit label {\n  font-weight: 600;\n  color: rgba(1, 41, 112, 0.6);\n}\n\n.profile .profile-edit img {\n  max-width: 120px;\n}\n\n/*--------------------------------------------------------------\n# F.A.Q Page\n--------------------------------------------------------------*/\n.faq .basic h6 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #4154f1;\n}\n\n.faq .basic p {\n  color: #6980aa;\n}\n\n/*--------------------------------------------------------------\n# Contact\n--------------------------------------------------------------*/\n.contact .info-box {\n  padding: 28px 30px;\n}\n\n.contact .info-box i {\n  font-size: 38px;\n  line-height: 0;\n  color: #4154f1;\n}\n\n.contact .info-box h3 {\n  font-size: 20px;\n  color: #012970;\n  font-weight: 700;\n  margin: 20px 0 10px 0;\n}\n\n.contact .info-box p {\n  padding: 0;\n  line-height: 24px;\n  font-size: 14px;\n  margin-bottom: 0;\n}\n\n.contact .php-email-form .error-message {\n  display: none;\n  color: #fff;\n  background: #ed3c0d;\n  text-align: left;\n  padding: 15px;\n  margin-bottom: 24px;\n  font-weight: 600;\n}\n\n.contact .php-email-form .sent-message {\n  display: none;\n  color: #fff;\n  background: #18d26e;\n  text-align: center;\n  padding: 15px;\n  margin-bottom: 24px;\n  font-weight: 600;\n}\n\n.contact .php-email-form .loading {\n  display: none;\n  background: #fff;\n  text-align: center;\n  padding: 15px;\n  margin-bottom: 24px;\n}\n\n.contact .php-email-form .loading:before {\n  content: \"\";\n  display: inline-block;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  margin: 0 10px -6px 0;\n  border: 3px solid #18d26e;\n  border-top-color: #eee;\n  -webkit-animation: animate-loading 1s linear infinite;\n  animation: animate-loading 1s linear infinite;\n}\n\n.contact .php-email-form input,\n.contact .php-email-form textarea {\n  border-radius: 0;\n  box-shadow: none;\n  font-size: 14px;\n  border-radius: 0;\n}\n\n.contact .php-email-form input:focus,\n.contact .php-email-form textarea:focus {\n  border-color: #4154f1;\n}\n\n.contact .php-email-form input {\n  padding: 10px 15px;\n}\n\n.contact .php-email-form textarea {\n  padding: 12px 15px;\n}\n\n.contact .php-email-form button[type=submit] {\n  background: #4154f1;\n  border: 0;\n  padding: 10px 30px;\n  color: #fff;\n  transition: 0.4s;\n  border-radius: 4px;\n}\n\n.contact .php-email-form button[type=submit]:hover {\n  background: #5969f3;\n}\n\n@-webkit-keyframes animate-loading {\n  0% {\n      transform: rotate(0deg);\n  }\n\n  100% {\n      transform: rotate(360deg);\n  }\n}\n\n@keyframes animate-loading {\n  0% {\n      transform: rotate(0deg);\n  }\n\n  100% {\n      transform: rotate(360deg);\n  }\n}\n\n/*--------------------------------------------------------------\n# Error 404\n--------------------------------------------------------------*/\n.error-404 {\n  padding: 30px;\n}\n\n.error-404 h1 {\n  font-size: 180px;\n  font-weight: 700;\n  color: #4154f1;\n  margin-bottom: 0;\n  line-height: 150px;\n}\n\n.error-404 h2 {\n  font-size: 24px;\n  font-weight: 700;\n  color: #012970;\n  margin-bottom: 30px;\n}\n\n.error-404 .btn {\n  background: #51678f;\n  color: #fff;\n  padding: 8px 30px;\n}\n\n.error-404 .btn:hover {\n  background: #3e4f6f;\n}\n\n@media (min-width: 992px) {\n  .error-404 img {\n      max-width: 50%;\n  }\n}\n\n/*--------------------------------------------------------------\n# Footer\n--------------------------------------------------------------*/\n.footer {\n  padding: 20px 0;\n  font-size: 14px;\n  transition: all 0.3s;\n  border-top: 1px solid #cddfff;\n}\n\n.footer .copyright {\n  text-align: center;\n  color: #012970;\n}\n\n.footer .credits {\n  padding-top: 5px;\n  text-align: center;\n  font-size: 13px;\n  color: #012970;\n}\n/*middle content css*/\n.write-post-container {\n  width: 100%;\n  background: var(--body-bg-color);\n  /* border-radius: 6px; */\n  padding: 20px;\n  color: #626262;\n}\n.post-container{\n  width:100%;\n  background: var(--body-bg-color);\n  border-radius: 6px;\n  padding: 20px;\n  color:var(--bs-wb-color);\n  margin:20px 0;\n}\n.post-input-container{\n  padding-left: 55px;\n  padding-top: 20px;\n}\n.post-input-container textarea{\n  width:100%;\n  border:0;\n  outline:0;\n  border-bottom:1px solid #ccc;\n  background:transparent;\n  resize:none;\n}\n.post-row{\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.user-profile a{\n  font-size: 12px;\n  color: var(--nav-color);\n  text-decoration: none;\n\n}\n.user-profile{\n  display: flex;\n  align-items: center;\n}\n.user-profile img{\n  width: 45px;\n  border-radius: 50%;\n  margin-right: 10px;\n}\n.user-profile p{\n  margin-bottom: 0px;\n  font-weight: 700;\n  color:#e30613;\n}\n.user-profile small{\n  font-size: 12px;\n}\n.add-post-links{\n  display: flex;\n  margin-top:10px;\n}\n.add-post-links a{\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  color:#626262;\n  margin-right: 30px;\n  font-size:13px;\n}\n.add-post-links a img{\n  width:20px;\n  margin-right:10px;\n\n}\n.post-text{\n  color:#9a9a9a;\n  margin:15px 0;\n  font-size:15px;\n}\n.post-text span{\n  color: #626262;\n  font-weight: 500;\n}\n\n.post-text a{\n  color:var(--nav-color);\n  text-decoration: none;\n}\n.post-img{\n  width:100%;\n  border-radius: 4px;\n  margin-bottom:5px;\n}\n.activity-icons div img{\n  width:18px;\n  margin-right:10px;\n}\n.activity-icons div {\n  display: inline-flex;\n  align-items: center;\n  margin-right:30px;\n}\n.post-profile-icon{\n  display:flex;\n  align-items: center;\n}\n.post-profile-icon img{\n  width:20px;\n  border-radius: 50%;\n  margin-right:5px;\n}\n.load-more-btn{\n  display: inherit;\n  margin:auto;\n  cursor:pointer;\n  padding: 5px 10px;\n  border:1px solid #9a9a9a;\n  color: #626262;\n  background: transparent;\n  border-radius:4px;\n}\n.miw-100{\n  min-width:100%\n}\n.divider{\n  border-top:1px solid var(--divider);\n  width:100%;\n  margin: 0.5em auto;\n  opacity:1;\n}\n\n\n#dark-btn{\n  position:absolute;\n  top:20px;\n  right:20px;\n  background:#ccc;\n  width:45px;\n  border-radius: 15px;\n  padding:3p 3px;\n  cursor: pointer;\n  display:flex;\n  transition: padding-left 0.5s, background 0.5s;\n}\n#dark-btn span{\n  width:18px;\n  height:18px;\n  background:var(--bg-color);\n  border-radius: 50%;\n  display: inline-block;\n\n}\n\n#dark-btn.dark-btn-on{\n  padding-left:23px;\n  background:#0a0a0a;\n\n}\n.sidebar-footer{\n  background-color: var(--body-bg-color);\n}\n.sidebar-footer .list-group .list-group-item{\n  padding:0;\n  border:none;\n  background:none;\n}\n\n.fs-1vw{\n  font-size:1.4vw!important\n}\n.fs-2vw{\n  font-size:2.5vw!important\n}\n#main .sticky-top{\n  top:55!important\n}\n\n.d-flex-mi{\n  display:inline-flex!important;\n  align-items: center;\n}\n\n.card-rounded-top{\n  border-radius: var(--bs-card-border-radius) var(--bs-card-border-radius) 0 0!important;\n}\n\n.ck.ck-editor__main>.ck-editor__editable{\n  background-color: var(--bs-bw-color)!important;\n}\n.ck-reset_all :not(.ck-reset_all-excluded *), .ck.ck-reset_all{\n  color: var(--bs-wb-color)!important;\n}\n\n.ck.ck-toolbar{\n  background-color: var(--bs-bw-color)!important;\n}\n.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused) {\n  border-color: #b4b4b4!important;\n}\n\n.btn-bw{\n  color:var(--bs-wb-color)!important;\n  background-color: var(--bs-bw-color)!important;\n}\n.btn-bw:hover{\n  color:#fff!important;\n  background-color:var(--bs-primary)!important\n}\n\n#sidebar .list-group{\n  max-height: 63vh;\n  /* margin-bottom: 10px; */\n  overflow:hidden;\n}\n\n#sidebar .sidebar-left, #rsidebar{\n  overflow:hidden;\n}\n#sidebar .sidebar-left:hover, #rsidebar:hover{\n  overflow-y: auto;\n  overflow-x:hidden;\n}\n#sidebar .list-group:hover{\n  overflow-y: auto;\n  overflow-x:hidden;\n}\n\n.custom-scrollbar-js,\n.custom-scrollbar-css {\n  height: 200px;\n\n}\n\n\n/* Custom Scrollbar using CSS */\n.custom-scrollbar-css {\n  overflow-y: scroll;\n}\n\n/* scrollbar width */\n.custom-scrollbar-css::-webkit-scrollbar {\n  width: 3px!important;\n}\n\n/* scrollbar track */\n.custom-scrollbar-css::-webkit-scrollbar-track {\n  background: var(--bs-dark);\n}\n\n/* scrollbar handle */\n.custom-scrollbar-css::-webkit-scrollbar-thumb {\n  border-radius: 1rem;\n  background-color: #e30613;\n  background-image: linear-gradient(to top, #ff0000 0%, #a8000b 100%);\n}\n\n@media only screen and (min-width: 600px) {\n  .lsbar{\n      left:-235px;\n  }\n  .header {\n      margin-left:0;\n  }\n  .main{\n      margin-left:0;\n  }\n}\n@media only screen and (min-width: 1200px) {\n  .lsbar{\n      left:0px;\n  }\n  .header {\n      margin-left:235px;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .header {\n      margin-left:0;\n  }\n  .main{\n      margin-left:0;\n  }\n  .lsbar{\n      left:-235px;\n  }\n\n  .border-0-sm {\n      border:0!important;\n  }\n}\n\n/*Profile card 2*/\n.profile-card-2 .card-img-block{\n  float:left;\n  width:100%;\n  height:150px;\n  overflow:hidden;\n}\n.profile-card-2 .card-body{\n  position:relative;\n}\n.card .profile {\n  position: absolute;\n  top: 110px;\n  left: 15%;\n  max-width: 75px;\n  /* border: 3px solid rgba(255, 255, 255, 1); */\n  -webkit-transform: translate(-50%, 0%);\n  transform: translate(-50%, 0%);\n}\n.profile-card-2 h5{\n  font-weight:600;\n  color:#6ab04c;\n}\n.profile-card-2 .card-text{\n  font-weight:300;\n  font-size:15px;\n}\n.profile-card-2 .icon-block{\n  float:left;\n  width:100%;\n}\n.profile-card-2 .icon-block a{\n  text-decoration:none;\n}\n.profile-card-2 i {\n  display: inline-block;\n  font-size: 16px;\n  color: #6ab04c;\n  text-align: center;\n  border: 1px solid #6ab04c;\n  width: 30px;\n  height: 30px;\n  line-height: 30px;\n  border-radius: 50%;\n  margin:0 5px;\n}\n.profile-card-2 i:hover {\n  background-color:#6ab04c;\n  color:#fff;\n}\n\n.counter {\n  font-size: 22px;\n  font-weight: 700;\n  letter-spacing: 0.1rem;\n}\n.month {\n  font-size: 18px;\n}\n\n/*  avatar css start*/\n.avatar-size-120{\n  width: 120px!important;\n  height: 120px!important\n}\n.avatar-size-50{\n  width: 50px!important;\n  height: 50px!important;\n}\n.avatar-size-40{\n  width: 40px!important;\n  height: 40px!important;\n}\n.avatar-size-30{\n  width: 30px!important;\n  height: 30px!important;\n}\n\n.avatar-container {\n  position: relative;\n}\n.avatar-container img {\n  height: 100%;\n  width: 100%;\n  border-radius: 50%;\n}\n.avatar-container span.initial{\n  border-radius:50%;\n  border: 1px solid var(--bs-gray-500);\n  background-color:#e30613;\n  font-size:20px;\n  font-weight:700;\n  color:#fff;\n  display:flex;\n  justify-content: center;\n  align-items: center;\n}\n.avatar-container .online{\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background-color: #17ca28;\n  border: 2px solid white;\n  top: 0;\n  right: 0;\n  position: absolute;\n}\n/* avatar css end */\n\n\n.avatar-30 img{\n  border: 1px solid var(--bs-gray-500);\n  width: 30px;\n  height: 30px;\n}\n.avatar-30 span.initial{\n  border-radius:50%;\n  text-transform:capitalize;\n  border: 1px solid var(--bs-gray-500);\n  min-width: 30px;\n  height: 30px;\n  background-color:#e30613;\n  font-size:20px;\n  font-weight:700;\n  color:#fff;\n  display:flex;\n  justify-content: center;\n  align-items: center;\n}\n/* .avatar-30::before {\nbox-shadow: 0 0 0 1px #fff; \nposition: absolute;\nwidth:6px;\nheight:6px;\nleft: 24px;\ntop: 4px;\ncontent: \"\";\nfont-size:2rem;\nborder-radius: 100%;\nbackground-color: #17ca28;\nz-index: 100;\nopacity: 0;\nvisibility: visible;  \n} */\n\n.avatar-30-active img{\n  border: 1px solid var(--bs-gray-500);\n  width: 30px;\n  height: 30px;\n}\n.avatar-30-active span.initial{\n  border-radius:50%;\n  text-transform:capitalize;\n  border: 1px solid var(--bs-gray-500);\n  min-width: 30px;\n  height: 30px;\n  background-color:#e30613;\n  font-size:20px;\n  font-weight:700;\n  color:#fff;\n  display:flex;\n  justify-content: center;\n  align-items: center;\n}\n.avatar-30-active::before {\n  box-shadow: 0 0 0 1px #fff;\n  position: absolute;\n  width:6px;\n  height:6px;\n  left: 24px;\n  top: 4px;\n  content: \"\";\n  font-size:2rem;\n  border-radius: 100%;\n  background-color: #17ca28;\n  z-index: 100;\n  opacity: 1;\n  visibility: visible;\n}\n\n.avatar-40 img{\n  border: 1px solid var(--bs-gray-500);\n  width: 40px;\n  height: 40px;\n}\n.avatar-40 span.initial{\n  border-radius:50%;\n  text-transform:capitalize;\n  border: 1px solid var(--bs-gray-500);\n  min-width: 40px;\n  height: 40px;\n  background-color:#e30613;\n  font-size:20px;\n  font-weight:700;\n  color:#fff;\n  display:flex;\n  justify-content: center;\n  align-items: center;\n}\n/* .avatar-40::before {\nbox-shadow: 0 0 0 1.5px #fff; \nposition: absolute;\nwidth:9px;\nheight:9px;\nleft: 32px;\ntop: 2px;\ncontent: \"\";\nfont-size:2rem;\nborder-radius: 100%;\nbackground-color: #17ca28;\nz-index: 100;\nopacity: 1;\nvisibility: visible;\n} */\n\n.avatar-40-active img{\n  border: 1px solid var(--bs-gray-500);\n  width: 40px;\n  height: 40px;\n}\n.avatar-40-active span.initial{\n  border-radius:50%;\n  text-transform:capitalize;\n  border: 1px solid var(--bs-gray-500);\n  min-width: 40px;\n  height: 40px;\n  background-color:#e30613;\n  font-size:20px;\n  font-weight:700;\n  color:#fff;\n  display:flex;\n  justify-content: center;\n  align-items: center;\n}\n.avatar-40-active::before {\n  box-shadow: 0 0 0 1.5px #fff;\n  position: absolute;\n  width:9px;\n  height:9px;\n  left: 32px;\n  top: 2px;\n  content: \"\";\n  font-size:2rem;\n  border-radius: 100%;\n  background-color: #17ca28;\n  z-index: 100;\n  opacity: 1;\n  visibility: visible;\n}\n\n.avatar-50 img{\n  border: 1px solid var(--bs-gray-500);\n  width: 50px;\n  height: 50px;\n}\n.avatar-50 span.initial{\n  border-radius:50%;\n  text-transform:capitalize;\n  border: 1px solid var(--bs-gray-500);\n  min-width: 50px;\n  height: 50px;\n  background-color:#e30613;\n  font-size:20px;\n  font-weight:700;\n  color:#fff;\n  display:flex;\n  justify-content: center;\n  align-items: center;\n}\n/* .avatar-50::before {\nbox-shadow: 0 0 0 1.5px #fff; \nposition: absolute;\nwidth:9px;\nheight:9px;\nleft: 47px;\ntop: 15px;\ncontent: \"\";\nborder-radius: 100%;\nbackground-color: #17ca28;\nz-index: 100;\nopacity: 0;\nvisibility: visible;\n} */\n\n\n.avatar-50-active img{\n  border: 1px solid var(--bs-gray-500);\n  width: 50px;\n  height: 50px;\n}\n.avatar-50-active span.initial{\n  border-radius:50%;\n  text-transform:capitalize;\n  border: 1px solid var(--bs-gray-500);\n  min-width: 50px;\n  height: 50px;\n  background-color:#e30613;\n  font-size:20px;\n  font-weight:700;\n  color:#fff;\n  display:flex;\n  justify-content: center;\n  align-items: center;\n}\n.avatar-50-active::before {\n  box-shadow: 0 0 0 1.5px #fff;\n  position: absolute;\n  width:9px;\n  height:9px;\n  left: 47px;\n  top: 15px;\n  content: \"\";\n  border-radius: 100%;\n  background-color: #17ca28;\n  z-index: 100;\n  opacity: 1;\n  visibility: visible;\n}\n\n.avatar-120 img{\n  border: 1px solid var(--bs-gray-500);\n  width: 120px;\n  height: 120px;\n}\n.avatar-120 span.initial{\n  border-radius:50%;\n  text-transform:capitalize;\n  border: 1px solid var(--bs-gray-500);\n  min-width: 120px;\n  height: 120px;\n  background-color:#e30613;\n  font-size:50px;\n  font-weight:700;\n  color:#fff;\n  display:flex;\n  justify-content: center;\n  align-items: center;\n}\n/* .avatar-120::before {\nposition: absolute;\nborder:1px solid #fff;\nwidth:15px;\nheight:15px;\nleft: 115px;\ntop: 30px;\ncontent: \"\";\nborder-radius: 100%;\nbackground-color: #17ca28;\nz-index: 100;\nopacity: 0;\nvisibility: visible;\n} */\n.avatar-120-active img{\n  border: 1px solid var(--bs-gray-500);\n  width: 120px;\n  height: 120px;\n}\n.avatar-120-active span.initial{\n  border-radius:50%;\n  text-transform:capitalize;\n  border: 1px solid var(--bs-gray-500);\n  min-width: 120px;\n  height: 120px;\n  background-color:#e30613;\n  font-size:50px;\n  font-weight:700;\n  color:#fff;\n  display:flex;\n  justify-content: center;\n  align-items: center;\n}\n.avatar-120-active::before {\n  position: absolute;\n  border:1px solid #fff;\n  width:15px;\n  height:15px;\n  left: 115px;\n  top: 30px;\n  content: \"\";\n  border-radius: 100%;\n  background-color: #17ca28;\n  z-index: 100;\n  opacity: 1;\n  visibility: visible;\n}\n.user-avatar {\n  width: 50px;\n  height: 50px;\n  border-radius: 100%;\n  background-size: cover;\n  background-position: 50% 50%;\n  position: relative;\n  border: 0.5px solid var(--bordercolor);\n}\n\n[placeholder]:focus::-webkit-input-placeholder {\n  color: transparent;\n}\n[placeholder]:focus::-webkit-input-placeholder {\n  transition: opacity 0.5s 0.5s ease;\n  opacity: 0;\n}\n\n.copyright{\n  line-height: 1!important;\n}\n.mention{\n  text-decoration: underline;\n  color:#e10613;\n  cursor:pointer;\n}\n\n\n#dd-notification .dropdown-toggle::after {\n  display: none !important; \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
